module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-not-found"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    staticClass: "text-center",
    staticStyle: {
      "height": "50vh"
    },
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Page not Found")]), _vm._v(" "), _c('h4', [_vm._v("Looks like you're the only one here.")]), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "router": "",
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("Time to go home")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5273e131","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-not-found/page-not-found.vue
// module id = 702
// module chunks = 0